import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Input, Button, Table } from 'antd';

const SelectTagsModal = ({
  formattedTags,
  onSelectTags,
  tagsColumns,
  rowType = 'checkbox', // TEMP: Allows to use radio button in publisher and checkbox in advertiser
  selectedTags = [], // Previously selected tags for editing
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState(selectedTags.map((tag) => tag.value));
  const [tableTags, setTableTags] = useState(formattedTags);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    // Sort tags: selected tags first, then unselected
    const sorted = [...formattedTags].filter((tag) => !tag.isOwned).sort((a, b) => {
      const aSelected = selectedRowKeys.includes(a.value) ? 0 : 1;
      const bSelected = selectedRowKeys.includes(b.value) ? 0 : 1;
      return aSelected - bSelected;
    });

    // Apply search filter if exists
    if (searchValue && searchValue !== '') {
      const filtered = sorted.filter((tag) =>
        tag.label.toLowerCase().includes(searchValue.toLowerCase())
      );
      setTableTags(filtered);
    } else {
      setTableTags(sorted);
    }
  }, [formattedTags, selectedRowKeys, searchValue]);

  const handleSearch = (value) => {
    setSearchValue(value);
  };

  const handleAddSelections = () => {
    const selected = tableTags
      .filter((tag) => selectedRowKeys.includes(tag.value))
      .map((tag) => ({
        ...tag,
        measuredEvents: [
          tag.sessions > 0 ? 'SESSIONS' : null,
          tag.transactions > 0 ? 'TRANSACTIONS' : null,
          tag.signups > 0 ? 'SIGN_UPS' : null,
          tag.basketItems > 0 ? 'BASKET_ITEMS' : null,
        ].filter(Boolean),
      }));
    onSelectTags(selected);
  };

  return (
    <Card
      title="Tags"
      extra={
        <Row gutter={16}>
          <Col>
            <Input.Search placeholder="Search Tags" allowClear onSearch={handleSearch} />
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={handleAddSelections}
              disabled={selectedRowKeys.length === 0}
              style={{ marginRight: '20px' }}
            >
              Add Selection(s)
            </Button>
          </Col>
        </Row>
      }
    >
      <Table
        dataSource={tableTags}
        columns={tagsColumns}
        rowKey={(record) => record.value}
        scroll={{ x: '100%' }}
        size="middle"
        rowSelection={{
          type: rowType,
          selectedRowKeys,
          onChange: (newSelectedRowKeys) => {
            setSelectedRowKeys(newSelectedRowKeys);
          },
        }}
      />
    </Card>
  );
};

export default SelectTagsModal;
